import React from "react";
import "./Body.css";

import { Container, Row, Col } from "reactstrap";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
library.add(faTimes, faCheck);

export default class Body extends React.Component {

    render() {
        return (
                <Container className="content-wrapper p-b-0">
                  <Row className="top-banner">
                    <Col sm="6" className="left">
                      <div>
                        <p className="small-text">LET'S TALK INTEGRATIONS</p>
                        <h1>
                          Join our Slack community; <i>Let's integrate!</i>
                        </h1>
                        <ul className="d-none d-sm-none d-md-block d-lg-block">
                          <p className="small-text"><i>Let's integrate </i> is a community of professionals sharing their insights on system integration with each other. </p>
                          <p className="small-text">We welcome specialists and enthusiastic generalists to connect, learn and inspire each other in this community. Anyone is can join, regardless of industry or continent, as long as you have a professional interest in system integrations.</p>
                          <p className="small-text"><bold>In this community, you can do awesome things:</bold></p>
                          <ul className="community-list">
                            <li>Connect and chat with fellow integrators
                            </li>
                            <li>Get help with integration problems
                            </li>
                            <li>Discuss your integration architecture challenges
                            </li>
                            <li>Learn new skills
                            </li>
                            <li>Build your network
                            </li>
                          </ul>
                          <p className="small-text">By joining, you agree to follow our <a href="/code-of-conduct">Code of Conduct </a></p>
                          <li>
                            <a className="int-btn blue-btn" href="https://join.slack.com/t/let-us-integrate/shared_invite/zt-1jwvheo4k-cHfGG7DiLN8dspAJHCALUg">
                              Join now
                            </a>
                          </li>
                        </ul>
                      </div>
                    </Col>
                    <Col md="6" className="right">
                      <img
                        className="img-fluid d-block mx-auto"
                        src="https://info.entiros.se/hs-fs/hubfs/aboutus-men.d0ab914c.png?width=350&height=462&name=aboutus-men.d0ab914c.png"
                        alt="Integrator"
                      />
                    </Col>
                    <ul className="d-lg-none d-md-none d-sm-block d-xs-block">
                      <li>
                        <a className="int-btn blue-btn" href="#certificate-box-block">
                          Learn More
                        </a>
                      </li>
                      <li>
                        <a className="int-btn green-btn" href="/get-certified">get certified</a>
                      </li>
                    </ul>
                  </Row>
                  <div className="under-banner">
                    <h3 className="text-center" id="certificate-box-block">Featured channels</h3>
                  </div>
                  <div className="row certificate-box-block">
                    <Col sm="4" className="certificate-box-left card slack">
                      <Col className="card-body col">
                        <h2 className="card-title">#certified-integrator</h2>
                        <p className="small-text">General discussion about the course.</p>
                      </Col>
                    </Col>
                    <Col sm="4" className="certificate-box-right card slack">
                      <Col className="card-body col">
                        <h3 className="card-title">#architecture</h3>
                        <p className="small-text">General discussions about integration architecture.</p>
                      </Col>
                    </Col>
                    <Col sm="4" className="certificate-box-right card slack">
                      <Col className="card-body col">
                        <h3 className="card-title">#tech</h3>
                        <p className="small-text">Talk about what tech solutions you use or want to know more about.</p>
                      </Col>
                    </Col>
                  </div>
                  <div className="row certificate-box-block">
                    <Col sm="4" className="certificate-box-left card slack">
                      <Col className="card-body col">
                        <h5 className="card-title">#documentation</h5>
                        <p className="small-text">Discuss best practices in documenting integration landscapes.</p>
                      </Col>
                    </Col>
                    <Col sm="4" className="certificate-box-right card slack">
                      <Col className="card-body col">
                        <h5 className="card-title">#security</h5>
                        <p className="small-text">A place to discuss and get help with integration security.</p>
                      </Col>
                    </Col>
                    <Col sm="4" className="certificate-box-right card slack">
                      <Col className="card-body col">
                        <h5 className="card-title">#life-cycle-mgmt</h5>
                        <p className="small-text">Discuss how to design integrations with life cycle management in mind.</p>
                      </Col>
                    </Col>
                  </div>
                </Container>
                );
    }
}